import { useEffect } from 'react';
import { useAuth } from '../../auth/hooks/auth';

declare global {
    interface Window {
        Tawk_API: any;
        Tawk_LoadStart: any;
    }
}

const TawkChat = () => {
    const { user } = useAuth();

    useEffect(() => {
        // Only run on client side
        if (typeof window === 'undefined') return;

        // Tawk.to Script Integration
        var s1 = document.createElement("script"),
            s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/6087372062662a09efc25d5d/1joghk9ks';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');

        if (s0 && s0.parentNode) {
            s0.parentNode.insertBefore(s1, s0);
        }

        // Cleanup on unmount
        return () => {
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src.includes('tawk.to')) {
                    scripts[i].parentNode?.removeChild(scripts[i]);
                }
            }
            if (window.Tawk_API && window.Tawk_API.hideWidget) {
                window.Tawk_API.hideWidget();
            }
        };
    }, []);

    // Synchronize user data with Tawk.to once logged in
    useEffect(() => {
        if (window.Tawk_API && user) {
            window.Tawk_API.onLoad = function () {
                window.Tawk_API.setAttributes({
                    'name': user.name,
                    'email': user.email,
                    'id': user.id
                }, function (error: any) { });
            };

            // If already loaded
            if (window.Tawk_API.setAttributes) {
                window.Tawk_API.setAttributes({
                    'name': user.name,
                    'email': user.email,
                    'id': user.id
                }, function (error: any) { });
            }
        }
    }, [user]);

    return null; // This component doesn't render any UI, Tawk.to handles it
};

export default TawkChat;
